export const AM_VIDEO_INTERVIEW_PACKAGE_TAG = 'AM_VIDEO_INTERVIEW';
